import * as Icons from "lucide-react";
import { WHY_US } from "@/lib/data";
import { Reveal, RevealStagger, StaggerItem, Cascade } from "@/components/Reveal";

const Icon = ({ name, className }) => {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} strokeWidth={1.5} />;
};

export default function WhyUs() {
  return (
    <section className="scroll-mt-24" data-testid="why-us">
      <div className="container-shell">
        <div className="grid grid-cols-1 gap-[56px] lg:grid-cols-[0.85fr_1.15fr] lg:gap-[80px]">
          {/* Sticky heading */}
          <div className="lg:sticky lg:top-32 lg:self-start">
            <Reveal>
              <p className="overline">Neden Tekno Şura?</p>
              <h2 className="heading-lg mt-4">
                <Cascade text="Güvenin {somut} karşılığı." />
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-ink/60">
                Sadece yazılım satmıyoruz; kurulumundan eğitimine, desteğinden bakımına kadar
                yanınızda oluyoruz.
              </p>
            </Reveal>
          </div>

          {/* Grid */}
          <RevealStagger className="grid grid-cols-1 gap-[32px] sm:grid-cols-2">
            {WHY_US.map((w) => (
              <StaggerItem key={w.title}>
                <div
                  className="group flex items-center gap-4 rounded-2xl border border-ink/5 bg-white p-6 transition-[transform,box-shadow] duration-400 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(32,32,32,0.08)]"
                  data-testid={`why-${w.title}`}
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-lime/15 text-[#7fa021] transition-colors duration-400 group-hover:bg-lime group-hover:text-white">
                    <Icon name={w.icon} className="h-6 w-6" />
                  </span>
                  <span className="text-base font-semibold text-ink">{w.title}</span>
                </div>
              </StaggerItem>
            ))}
          </RevealStagger>
        </div>
      </div>
    </section>
  );
}
